import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';



export default function Home(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();



    function updateDynamicUrlParam(key, value) {
        searchParams.delete(key)
        if (value !== '') searchParams.set(key, value)
        setSearchParams(searchParams)
    }



    const handleBack = () => {
        //for desktop browser, navigate to home page
        if (window?.innerWidth > 768) {
            navigate('/')
            return
        }

        window?.ReactNativeWebView?.postMessage('close')
        navigate(-1)
    }



    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden" style={{ overflow: 'auto' }}>

            <div className='relative w-full'>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/successful.png' className="w-full"  style={{height:'auto',objectFit:'contain'}}/>
                <div className='w-[50%] absolute bottom-[20%] left-[25%] h-[10%]' onClick={handleBack}></div>
            </div>

            {/* back button, fixed at top left corner,, round, shadow */}
            {/* <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div> */}
        </div >
    )
}
